import { PlotsListPage } from '@/components/plots/plots-list-page'

export function CommitteePlots() {
  return (
    <PlotsListPage
      plotsBasePath="/committee/plots"
      membersBasePath="/committee/members"
      canManage={false}
    />
  )
}
